(() => {
  const els = Array.from(document.querySelectorAll('[data-stat-circle]'));
  if (!els.length) return;

  const COUNT_MS = 3000;
  const STAGGER_MS = 1000;
  const easeOutQuint = (t) => 1 - Math.pow(1 - t, 5);
  const desktop = window.matchMedia('(min-width: 1024px)');

  function parts(el) {
    return {
      arc: el.querySelector('.stat-circle__progress'),
      value: el.querySelector('.stat-circle__value'),
      target: parseFloat(el.dataset.statValue || '0'),
    };
  }

  function showFinal(el) {
    const { arc, target } = parts(el);
    el.classList.add('is-visible');
    if (arc) arc.style.strokeDashoffset = String(100 - target);
  }

  function animate(el) {
    const { arc, value, target } = parts(el);
    el.classList.add('is-visible');

    const text = value ? value.textContent : '';
    const numMatch = text.match(/-?\d+(\.\d+)?/);
    const targetNum = numMatch ? parseFloat(numMatch[0]) : target;

    if (value && numMatch) value.textContent = text.replace(numMatch[0], '0');

    const start = performance.now();
    function frame(now) {
      const t = Math.min(1, (now - start) / COUNT_MS);
      const p = easeOutQuint(t);
      if (value && numMatch) {
        value.textContent = text.replace(numMatch[0], String(Math.round(targetNum * p)));
      }
      if (arc) arc.style.strokeDashoffset = String(100 - target * p);
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(showFinal);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        const group = Array.from(el.parentElement.querySelectorAll('[data-stat-circle]'));
        const delay = desktop.matches ? group.indexOf(el) * STAGGER_MS : 0;
        setTimeout(() => animate(el), Math.max(0, delay));
      });
    },
    { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
  );

  els.forEach((el) => observer.observe(el));
})();
